<template>
  <div>
    <PageHeader title="Devis" />
    <Tabs :tabs="tabs" class="mb-6">
      <template #processing>
        <LeadsListProcessing />
      </template>
      <template #failed>
        <LeadsListFailed />
      </template>
      <template #all>
        <LeadsIndex :storeId="selectedStoreId" />
      </template>
    </Tabs>
  </div>
</template>

<script>
import LeadsIndex from "@/components/leads/LeadsIndex.vue";
import LeadsListProcessing from "@/components/leads/LeadsListProcessing.vue";
import LeadsListFailed from "@/components/leads/LeadsListFailed.vue";
import { mapGetters } from "vuex";
import { PageHeader, Tabs } from "@estaly/ui";

export default {
  components: {
    LeadsIndex,
    LeadsListProcessing,
    LeadsListFailed,
    PageHeader,
    Tabs,
  },
  data() {
    return {
      tabs: [
        {
          name: "processing",
          displayName: "SEPA (via RIB) en attente de confirmation",
          current: true,
        },
        {
          name: "failed",
          displayName: "SEPA (via RIB) echoués",
          current: false,
        },
        {
          name: "all",
          displayName: "Tous",
          current: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("store", ["selectedStoreId"]),
  },
};
</script>
